/* SafetyNumberCard — settings-row card, not a list item (deliberately not
 * built on `.list`/`<li>` — see SidePanelNotificationList.module.css's
 * `.list > li` flex-column override, which would hijack any reused
 * `.list` class name). Surface/border/radius mirror PrivacyAppCard's
 * `.card` for visual consistency with other settings-adjacent cards. */
.card {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
  padding: var(--spacing-16);
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-8);
  background: var(--bg-secondary);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-8);
}

/* Digit grid — 4 columns x 3 rows at typical widths for the canonical
 * 12-group fingerprint. `auto-fit` (not a hardcoded 4-column track plus
 * a width media query) so the grid reflows to fewer columns in a
 * narrower host — e.g. the extension popup — without a breakpoint,
 * consistent with how the rest of this package avoids width-based
 * `@media` queries in favor of flexible layout. */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(56px, 1fr));
  gap: var(--spacing-8);
}

.group {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-4) var(--spacing-8);
  border-radius: var(--radius-4);
  background: var(--bg-tertiary);
  /* Monospace digits per spec — a platform stack literal, not a design
   * token; mirrors ClipCard's `.content` font-family (no monospace
   * token exists in tokens-figma.ts). Order matters: the `font`
   * shorthand resets font-family, so it MUST come first — the override
   * after it is what actually survives. */
  font: var(--text-micro-medium);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  color: var(--text-primary);
}

.group[data-masked] {
  color: var(--text-tertiary);
  letter-spacing: 0.15em;
}

/* Standard sr-only pattern (matches ClipCard/PairingView) — visually
 * hidden but read by AT. Used for the masked-grid hint. */
.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
